import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface ScanningSettingsFormValues {
  ticket_start_days: number;
}

export const scanningSettingsDefaultValues: ScanningSettingsFormValues = {
  ticket_start_days: 90
};

export const scanningSettingsSchema = yup.object({
  ticket_start_days: yup.number().required('Ticket start days is required').min(1, 'Min: 1 day').max(365, 'Max: 365 days')
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useScanningSettingsForm(initialValues?: any) {
  return useForm({
    values: initialValues || scanningSettingsDefaultValues,
    mode: 'onSubmit',
    resolver: yupResolver(scanningSettingsSchema),
    defaultValues: { ...scanningSettingsDefaultValues, ...initialValues }
  });
}
